import { useEffect, useRef } from 'react';
import { socket } from '../utils/api';

const useInvoices = (onUpdate) => {
  const callback = useRef(onUpdate);

  useEffect(() => {
    socket.on(`invoice`, (message) => {
      if (message.caller !== socket.id) {
        callback.current(message.data.type, message.name, message.data.number);
      }
    });
    return () => {
      socket.off(`invoice`);
    };
  }, []);
};

export default useInvoices;
